/* Class for storing parsing messages */
class ParsingMessage {
    protected constructor(
        public readonly position: number,
        public readonly message: string,
        private readonly level: "error" | "warning") {
    }

    public toString(): string {
        return `Parsing ${this.level} at position ${this.position}: ${this.message}`;
    }
}

export default ParsingMessage;
